import {IMapMarkerIconProps, MapMarkerIconInstance} from "./MapMarkerIcon";
import * as React from "react";
import {Point} from "maplibre-gl";
import {requirePoint} from "../utils/MapUtils";

export class MapMarkerImageIconInstance extends MapMarkerIconInstance
{

    imageWidth = 0;
    imageHeight = 0;

    imageIconOrigin:Point|null = null;
    imageIconInternalOrigin:Point|null = null;
    imageIconTopLeftAdditionalOffset:Point|null = null;
    imageIconBottomRightAdditionalOffset:Point|null = null;

    initialize() {
        super.initialize();
        this.determineSize()
    }

    applyNextProps(nextProps: IMapMarkerIconProps, props?: IMapMarkerIconProps)
    {
        super.applyNextProps(nextProps, props);

        this.imageIconOrigin = nextProps.imageIconOrigin ? requirePoint(nextProps.imageIconOrigin) : null;
        this.imageIconInternalOrigin = nextProps.imageIconInternalOrigin ? requirePoint(nextProps.imageIconInternalOrigin) : null;
        this.imageIconTopLeftAdditionalOffset = nextProps.imageIconTopLeftAdditionalOffset ? requirePoint(nextProps.imageIconTopLeftAdditionalOffset) : null;
        this.imageIconBottomRightAdditionalOffset = nextProps.imageIconBottomRightAdditionalOffset ? requirePoint(nextProps.imageIconBottomRightAdditionalOffset) : null;
    }

    determineSize() {
        if(!this.props.imagePath){
            return;
        }
        const img = new Image();

        img.onload = () =>{
            this.imageWidth = img.width;
            this.imageHeight = img.height;
        }
        img.src = this.props.imagePath;
    }

    getOrigin():Point|null
    {
        return this.imageIconOrigin;
    }

    getInternalOrigin():Point|null
    {
        return this.imageIconInternalOrigin;
    }

    getTopLeftAdditionalOffset():Point|null
    {
        return this.imageIconTopLeftAdditionalOffset ?? new Point(-4, -4);
    }

    getBottomRightAdditionalOffset():Point|null
    {
        return this.imageIconBottomRightAdditionalOffset ?? new Point(4, 1);
    }

    renderComponent()
    {
        const origin = this.getOrigin() ?? new Point(0, 0);
        const translateX = (100 * origin.x);
        const translateY = (100 * origin.y);
        return <img
            className="icon"
            alt="icon"
            src={this.props.imagePath}
            style={{
                transform: "scale("+this.scale+")" + (translateX ? " translateX(" + translateX +"%)" : "" ) + (translateY ? " translateY(" + translateY +"%)" : "" )
            }}
        />
    }
}
const MapMarkerImageIcon  = React.memo(MapMarkerImageIconInstance);
export default MapMarkerImageIcon;